<div class="row">
    <div class="col-12">
        <div class="card">
            <div class="card-body">
                <div class="row">
                    <div class="col-12">
                        <div class="row portfolio-grid">
                            <ng-container *ngFor="let influencer of influencers">

                                <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-6"
                                     (click)="router.navigate(['stars/single', influencer.influencer.id])">
                                    <figure class="effect-text-in">
                                        <div
                                                (click)="router.navigate(['stars/single', influencer.influencer.id])"
                                                class="card-img-top animated fadeIn influencer-image"
                                                *ngIf="influencer.image"
                                                [lazyLoad]="constants.imagesUrl() + '/images/600x350/' + influencer.image.type + '/' + influencer.image.name + '/'">
                                        </div>

                                        <figcaption (click)="router.navigate(['stars/single', influencer.influencer.id])">
                                            <h4>{{ influencer.influencer.name }}</h4>
                                            <p>{{ influencer.influencer.duty }}</p>
                                        </figcaption>
                                    </figure>
                                </div>

                            </ng-container>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
